/**
 * Funding Settings typography — Desktop-856 / Desktop-863 (Inter).
 * Scoped to Funding UI only; app chrome stays Poppins via index.css.
 */
export const fundingFont =
  'Inter, "Helvetica Neue", Helvetica, Arial, sans-serif'

/** Named styles matching Figma type scale (spread into tss-react classes). */
export const fundingType = {
  cardTitle: {
    fontFamily: fundingFont,
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  sectionTitle: {
    fontFamily: fundingFont,
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  fieldLabel: {
    fontFamily: fundingFont,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  body: {
    fontFamily: fundingFont,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  bodyMedium: {
    fontFamily: fundingFont,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
  },
  helper: {
    fontFamily: fundingFont,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
  },
  linkHelper: {
    fontFamily: fundingFont,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
  },
  chip: {
    fontFamily: fundingFont,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
  },
  button: {
    fontFamily: fundingFont,
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  breadcrumb: {
    fontFamily: fundingFont,
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '27px',
  },
} as const
